import { render, staticRenderFns } from "./AddressBookEdit.vue?vue&type=template&id=a002d73a&scoped=true&"
import script from "./AddressBookEdit.vue?vue&type=script&lang=js&"
export * from "./AddressBookEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a002d73a",
  null
  
)

export default component.exports